import React from 'react';
import './index.scss';

const Button = props => {
    return (
        <button
            className={props.className ? props.className : ''}
            id={props.id}
            disabled={props.disabled}
            onClick={props.onClick}
            tabIndex={props.tabIndex}
        >
            {props.label || props.text}
        </button>
    );
};

export default Button;
